export type RuntimeEnvKey = keyof ImportMetaEnv | string;

function readBuildEnv(key: RuntimeEnvKey): string {
  const v = (import.meta.env as Record<string, unknown>)[String(key)];
  return typeof v === 'string' ? v : '';
}

export function readEnv(key: RuntimeEnvKey): string {
  return readBuildEnv(key).trim();
}

export function requiredEnv(key: RuntimeEnvKey): string {
  const k = String(key).trim();

  // Support two patterns:
  // 1) requiredEnv('VITE_SOME_KEY') where we look up `import.meta.env[VITE_SOME_KEY]`
  // 2) requiredEnv(import.meta.env.VITE_SOME_KEY) where Vite may inline the value at build time
  const isEnvKeyLike = /^VITE_[A-Z0-9_]+$/.test(k);
  const v = isEnvKeyLike ? readEnv(k) : k;
  if (!v) throw new Error(`Missing env var: ${k}`);
  return v;
}

